export const SET_PACKAGES = 'SET_PACKAGES';
export const CLEAR_SERVICES = 'CLEAR_SERVICES';
export const CLEAR_PACKAGES = 'CLEAR_PACKAGES';
export const SET_EXACT_MILEAGE_FLAG = 'SET_EXACT_MILEAGE_FLAG';



// WEBPACK FOOTER //
// ./src/store/reducers/packages/actionTypes.js